<template>
  <Layout :quickActions="quickActions" :navTabs="navTabs" role="practitioner">
    <keep-alive include="practitionerChat">
      <router-view></router-view>
    </keep-alive>
  </Layout>
</template>

<script>
import { Client } from "twilio-chat";
import { mapActions, mapGetters, mapMutations } from "vuex";

import Layout from "@/components/Layout";

export default {
  name: "practitionerView",
  components: {
    Layout,
  },
  data() {
    return {
      client: null,
    };
  },
  computed: {
    ...mapGetters("profileSettings", ["practitionerSettings", "avatar"]),
    ...mapGetters("chat", ["token", "selectedChannel"]),

    navTabs() {
      return [
        {
          id: "visitCenter",
          title: this.$t("practitioner.appointments.title"),
          icon: "sidebar/calendar.svg",
          to: "/practitioner/appointments",
        },
        {
          id: "patients",
          title: this.$t("patients.title"),
          icon: "sidebar/user.svg",
          to: "/practitioner/patients",
        },
        {
          id: "messages",
          title: this.$t("general.sidebar.messages"),
          icon: "sidebar/messages.svg",
          to: "/practitioner/chat",
        },
      ];
    },
    quickActions() {
      return [
        {
          id: "scheduleVisit",
          title: this.$t("general.sidebar.scheduleVisit"),
          icon: "sidebar/visit.svg",
          to: "/practitioner/encounters/schedule",
        },
        {
          id: "invitePatient",
          title: this.$t("general.sidebar.invitePatient"),
          icon: "sidebar/user-plus.svg",
          action: "toggleInviteDialog",
        },
      ];
    },
  },
  methods: {
    ...mapActions("profileSettings", ["getPractitionerSettings"]),
    ...mapActions("chat", ["connect"]),
    ...mapMutations("chat", ["setUnreadChannels"]),
  },
  async mounted() {
    await this.getPractitionerSettings();
    this.$root.$i18n.locale = this.practitionerSettings.locale;

    await this.connect();
    this.client = await Client.create(this.token);
    const channelDescriptors = await this.client.getUserChannelDescriptors();
    const unconsumedObj = channelDescriptors.items.reduce((acc, channelDescriptor) => {
      acc[channelDescriptor.sid] = channelDescriptor.descriptor.unread_messages_count;
      return acc;
    }, {});
    this.setUnreadChannels(unconsumedObj);

    const channels = await Promise.all(
      channelDescriptors.items.map((ch) => {
        return ch.getChannel();
      }),
    );
    channels.forEach((ch) => {
      ch.on("updated", async (c) => {
        if (c.channel.sid === this.selectedChannel) return;
        const updatedUnreadCount = await c.channel.getUnconsumedMessagesCount();
        this.setUnreadChannels({ [c.channel.sid]: updatedUnreadCount });
      });
    });
  },
};
</script>
